module.exports = __webpack_public_path__ + "53fab65d8043f469204bef53242d612c.png";